<template>
  <el-dialog :title="getTitle"
             :visible.sync="showType"
             :close-on-click-modal="false"
             @close="handleCancel"
             width="40%">
    <el-col :span="24">
      <el-form :model="typeForm"
               :rules="typeRules"
               ref="typeForm"
               label-width="110px"
               class="type-form">
        <el-form-item label="规则组名称："
                      prop="name">
          <el-input v-model.trim="typeForm.name"
                    placeholder="请输入规则组名称"></el-input>
        </el-form-item>
        <el-form-item label="备注："
                      prop="remark">
          <el-input v-model.trim="typeForm.remark"
                    placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/pass_group/add' || '/pass_group/edit'"
                 type="primary"
                 @click="handleConfirm('typeForm')">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  computed: {
    getTitle() {
      return this.data.type === 'add' ? '添加门禁组' : '编辑门禁组'
    }
  },
  data() {
    return {
      showType: this.isShow,
      typeForm: {
        name: '',
        remark: ''
      },
      typeRules: {
        name: [{ required: true, message: '请输入规则组名称' }]
      }
    }
  },
  created() {
    if (this.data.type === 'edit') {
      this.getInfo()
    }
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getPassGroupInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.typeForm = data
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.data.type === 'add') {
            fetch.addPassGroup({ ...this.typeForm }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          } else {
            fetch.editPassGroup({ ...this.typeForm }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          }
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    }
  }
}
</script>

<style></style>
